import {
  obterIdEmpresa,
  obterNomeEmpresa,
  obterDocumentoEmpresa,
} from "../utils/empresa.js";

/**
 * Conversores entre o payload bruto do backend e o modelo simplificado
 * usado pela UI de Acompanhamento.
 */

const CHAVES_EMPRESA_EM_ITEM = ["empresa", "cadastro", "estudante"];

function extrairEmpresa(item) {
  if (!item || typeof item !== "object") return null;
  for (const chave of CHAVES_EMPRESA_EM_ITEM) {
    if (item[chave] && typeof item[chave] === "object") return item[chave];
  }
  return item;
}

/**
 * Normaliza um item de acompanhamento para o formato:
 *   { id, nome, documento, raw }
 * Retorna null quando o item não tem ID válido.
 */
export function normalizarEmpresaAcompanhamentoItem(item) {
  if (!item || typeof item !== "object") return null;

  const fonteEmpresa = extrairEmpresa(item);
  const id = obterIdEmpresa(fonteEmpresa) || obterIdEmpresa(item);
  if (!id) return null;

  const nome = obterNomeEmpresa(fonteEmpresa) || obterNomeEmpresa(item);
  const documento =
    obterDocumentoEmpresa(fonteEmpresa) || obterDocumentoEmpresa(item);

  return {
    id,
    nome,
    documento,
    raw: item,
  };
}

export function deduplicarAcompanhamentosPorEmpresa(lista) {
  if (!Array.isArray(lista)) return [];

  const mapa = new Map();
  for (const item of lista) {
    if (!item?.id) continue;
    if (!mapa.has(item.id)) mapa.set(item.id, item);
  }
  return Array.from(mapa.values());
}
